export default [
    {
        path: '/online-appointment',
        name: 'online-appointment',
        component: () => import('@/views/page/online-appointment/OnlineAppointment.vue'),
        meta: {
            layout: 'online-appointment'
        }
    },
    {
        path: '/doctor-profile/:resourceId/appointment',
        name: 'doctor-profile-appointment',
        component: () => import('@/views/page/online-appointment/DoctorProfile.vue'),
        meta: {
            layout: 'online-appointment'
        }
    }
]